import Vue from 'vue'
import App from './App.vue'

import vuetify from './plugins/vuetify';

import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import Routes from './routes.js'

Vue.config.productionTip = false

Vue.use(VueResource);
Vue.use(VueRouter);

const router = new VueRouter({
  routes: Routes,
  mode: "history"

});

Vue.mixin({
  methods: {
    getHost() {
      if (window.location.origin.includes("localhost")) {
        return "http://localhost/";
      }
      return window.location.origin + '/';
    }
  }
})


Vue.filter('prettify', function (value) {
  if (!value) return ''
  value = value.replace("_", " ")
  return value.charAt(0).toUpperCase() + value.slice(1)
})

new Vue({
  vuetify,
  render: h => h(App),
  router: router
}).$mount('#app')
